import { InvoiceContextProvider } from "./context/invoice_context";
import InvoiceLayout from "./invoice_layout";

const InvoicePage = () => {
  return (
    <InvoiceContextProvider>
      <InvoiceLayout />
    </InvoiceContextProvider>
  );
};

export default InvoicePage;
